<form [formGroup]="formGroup">
  <div class="card-data">
    <h4>{{ "Personal Data" | translate }}</h4>
    <div class="row m-0">

      <!-- Full Name -->
      <div class="col-12 col-sm-6">
        <label>{{ "Full Name" | translate }}<span style="color: red;">*</span></label>
        <input type="text" placeholder="{{ 'Enter your Full Name' | translate }}" formControlName="name" />
        <div class="error" *ngIf="formGroup.get('name')?.touched && formGroup.get('name')?.invalid">
          <span *ngIf="formGroup.get('name')?.errors?.['required']">
            {{ "Full Name is required" | translate }}
          </span>
          <span *ngIf="formGroup.get('name')?.errors?.['minlength']">
            {{ "Full Name must be at least 3 characters" | translate }}
          </span>
        </div>
      </div>

      <!-- Phone Number -->
      <div class="col-12 col-sm-6">
        <label>{{ "Phone Number" | translate }}<span style="color: red;">*</span></label>
        <input type="text" placeholder="{{ 'Enter your phone number' | translate }}" formControlName="phone" />
        <div class="error" *ngIf="formGroup.get('phone')?.touched && formGroup.get('phone')?.invalid">
          <span *ngIf="formGroup.get('phone')?.errors?.['required']">
            {{ "Phone number is required" | translate }}
          </span>
          <span *ngIf="formGroup.get('phone')?.errors?.['minlength']">
            {{ "Phone number must be at least 8 digits" | translate }}
          </span>
        </div>
      </div>

      <!-- Email -->
      <div class="col-12 col-sm-6">
        <label>{{ "Email" | translate }} <span style="color: red;">*</span></label>
        <input type="text" placeholder="{{ 'Enter your email' | translate }}" formControlName="email" />
        <div class="error" *ngIf="formGroup.get('email')?.touched && formGroup.get('email')?.invalid">
          <span *ngIf="formGroup.get('email')?.errors?.['required']">
            {{ "Email is required" | translate }}
          </span>
          <span *ngIf="formGroup.get('email')?.errors?.['pattern']">
            {{ "Invalid email format" | translate }}
          </span>
        </div>
      </div>

      <!-- Country -->
      <div class="col-12 col-sm-6">
        <label>{{ "Country" | translate }}<span style="color: red;">*</span></label>
        <input type="text" placeholder="{{ 'Enter your country' | translate }}" formControlName="country" />
        <div class="error" *ngIf="formGroup.get('country')?.touched && formGroup.get('country')?.invalid">
          <span *ngIf="formGroup.get('country')?.errors?.['required']">
            {{ "Country is required" | translate }}
          </span>
          <span *ngIf="formGroup.get('country')?.errors?.['minlength']">
            {{ "Country must be at least 2 characters" | translate }}
          </span>
        </div>
      </div>

      <!-- City (Optional, no errors) -->
      <div class="col-12 col-sm-6">
        <label>{{ "City" | translate }}</label>
        <input type="text" placeholder="{{ 'Enter your city' | translate }}" formControlName="city" />
      </div>

      <!-- LinkedIn -->
      <div class="col-12 col-sm-6">
        <label>{{ "LinkedIn" | translate }} <span style="color: red;">*</span></label>
        <input type="text" placeholder="{{ 'Enter your LinkedIn' | translate }}" formControlName="linkedIn" />
        <div class="error" *ngIf="formGroup.get('linkedIn')?.touched && formGroup.get('linkedIn')?.invalid">
          <span *ngIf="formGroup.get('linkedIn')?.errors?.['required']">
            {{ "LinkedIn is required" | translate }}
          </span>
          <span *ngIf="formGroup.get('linkedIn')?.errors?.['pattern']">
            {{ "Invalid LinkedIn URL" | translate }}
          </span>
        </div>
      </div>

      <!-- Job title -->
      <div class="col-12 col-sm-6">
        <label>{{ "Job title" | translate }}<span style="color: red;">*</span></label>
        <input type="text" placeholder="{{ 'Enter your job title' | translate }}" formControlName="title" />
        <div class="error" *ngIf="formGroup.get('title')?.touched && formGroup.get('title')?.invalid">
          <span *ngIf="formGroup.get('title')?.errors?.['required']">
            {{ "Job title is required" | translate }}
          </span>
          <span *ngIf="formGroup.get('title')?.errors?.['minlength']">
            {{ "Job title must be at least 2 characters" | translate }}
          </span>
        </div>
      </div>

      <!-- Portfolio -->
      <div class="col-12 col-sm-6">
        <label>{{ "Portfolio" | translate }}</label>
        <input type="text" placeholder="{{ 'Enter your portfolio URL' | translate }}" formControlName="portfolio" />
        <div class="error" *ngIf="formGroup.get('portfolio')?.touched && formGroup.get('portfolio')?.invalid">
          <span *ngIf="formGroup.get('portfolio')?.errors?.['pattern']">
            {{ "Invalid portfolio URL" | translate }}
          </span>
        </div>
      </div>

      <!-- Objective -->
      <div class="col-12">
        <label>{{ "Objective" | translate }}</label>
        <textarea type="text" placeholder="{{ 'Enter your objective' | translate }}"
          formControlName="summary"></textarea>
        <div class="error" *ngIf="formGroup.get('summary')?.touched && formGroup.get('summary')?.invalid">
          <span *ngIf="formGroup.get('summary')?.errors?.['required']">
            {{ "Objective is required" | translate }}
          </span>
          <span *ngIf="formGroup.get('summary')?.errors?.['minlength']">
            {{ "Objective must be at least 20 characters" | translate }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="next-container px-4">
    <button class="border-button m-3" (click)="onPrevious()">
      {{ "Back" | translate }}
    </button>
    <button class="gradient-button m-3" (click)="onNext()">
      {{ "Next" | translate }}
    </button>
  </div>
</form>